// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__1TWgM","paginationButton":"Pagination_paginationButton__1zOJq","paginationInfo":"Pagination_paginationInfo__3XUiE"};